import React from 'react'
import { Tag } from 'antd'
import { useTranslation } from 'react-i18next'

import type { ValidationAssetStatus } from '../../../types/modelValidation'

const statusColors: Record<ValidationAssetStatus, string> = {
    disabled: 'default',
    draft: 'processing',
    published: 'success',
}

export const ValidationAssetStatusTag: React.FC<{
    status: ValidationAssetStatus
}> = ({ status }) => {
    const { t } = useTranslation(['admin'])

    return (
        <Tag color={statusColors[status]}>
            {t(`admin:modelValidation.status.${status}`)}
        </Tag>
    )
}
